"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.dividerColors = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    divider: {},
    whiteTransparent: {
      backgroundColor: (0, _core.fade)(theme.palette.common.white, 0.32)
    },
    greyOne: {
      backgroundColor: theme.palette.grey[100]
    },
    greyTwo: {
      backgroundColor: theme.palette.grey[200]
    },
    greyThree: {
      backgroundColor: theme.palette.grey[700]
    },
    greyFour: {
      backgroundColor: theme.palette.grey[800]
    },
    greyFive: {
      backgroundColor: theme.palette.grey[900]
    },
    red: {
      backgroundColor: theme.palette.primary.main
    }
  };
});
/**
 * ** A divider is a thin line that separates content into clear groups. **
 */

var Divider = function Divider(_ref) {
  var _classNames;

  var color = _ref.color;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.divider, true), _defineProperty(_classNames, styles[color], true), _classNames))
  });
};

Divider.propTypes = {
  /** The available colors of divider */
  color: _propTypes.default.oneOf(["whiteTransparent", "red", "greyOne", "greyTwo", "greyThree", "greyFour", "greyFive"])
};
Divider.defaultProps = {
  color: "greyThree"
};
var dividerColors = ["whiteTransparent", "red", "greyOne", "greyTwo", "greyThree", "greyFour", "greyFive"];
exports.dividerColors = dividerColors;
var _default = Divider;
exports.default = _default;